// Settings.jsx
import React, { useEffect, useState } from "react";
import { Container, Button, Table, Modal, Form, Row, Col } from "react-bootstrap";
import { FaUserShield, FaEdit, FaTrash } from "react-icons/fa";
import "./CustomerList.css";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import axios from "axios";

// const LS_KEY = "app_users_v1";


// function readUsers() {
//   const raw = localStorage.getItem(LS_KEY);
//   if (!raw) return [];
//   try {
//     return JSON.parse(raw);
//   } catch {
//     return [];
//   }
// }

// function saveUsers(users) {
//   localStorage.setItem(LS_KEY, JSON.stringify(users));
// }

function nextUserId(existing) {
  if (!existing || !existing.length) return 1;
  return Math.max(...existing.map((u) => u.id || 0)) + 1;
}

const Settings = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [userList, setUserList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeId, setEmployeeId] = useState(null);

  // const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // form state and editing id (null = add mode)

  const [formData, setFormData] = useState({
    emp_id: "",
    desig_id: "",
    user_id: "",
    email: "",
    login_status: "",
  });

  // Get available designations from master data
  // const designations = Object.keys(MASTER_DATA);

  // Get employees based on selected designation
  // const getEmployeesByDesignation = (designation) => MASTER_DATA[designation] || [];

  useEffect(() => {
    // setLoading(true);
    axios.post(`${API_BASE_URL}employee_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setEmployeeList(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setEmployeeList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setEmployeeList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setUserList(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setUserList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setUserList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

    axios.post(`${API_BASE_URL}designation_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setDesignationList(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDesignationList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDesignationList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);
  // console.log("user list ",userList);
  console.log("designation list ", designationList);
  // console.log("formData.desig_id",formData.desig_id);

  const filteredUsers = userList.filter(
    (u) => u.desig_id === formData.desig_id
  );


  const openAddModal = () => {
    setEmployeeId(null);
    setFormData({ emp_id: "", desig_id: "", user_id: "", email: "" });
    setShowModal(true);
  };

  const openEditModal = (employee) => {
    setEmployeeId(employee.emp_id);
    setFormData({
      emp_id: employee.emp_id || "",
      desig_id: employee.desig_id || "",
      user_id: employee.user_id || "",
      email: employee.email || "",
      login_status: "0",
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEmployeeId(null);
    setFormData({ emp_id: "", desig_id: "", user_id: "", email: "" });
  };

  const handleDesignationChange = (e) => {
    const desig_id = e.target.value;

    setFormData({
      emp_id: employeeId,
      desig_id,
      user_id: "",
      email: "",
    });
  };

  /*
    const handleNameChange = (e) => {
      const selectedName = e.target.value;
      // const selectedEmployee = getEmployeesByDesignation(formData.designation).find(
      //   (emp) => emp.name === selectedName
      // );
      setFormData({
        ...formData,
        name: selectedName,
        // email: selectedEmployee ? selectedEmployee.email : "",
        name: "",
      });
    };
    */
  const handleNameChange = (e) => {
    const selectedUserId = e.target.value;

    const selectedUser = userList.find(
      (u) => u.user_id === selectedUserId
    );

    setFormData({
      ...formData,
      user_id: selectedUserId,
      email: selectedUser ? selectedUser.email : "",
    });
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    const { user_id, desig_id, email } = formData;
    if (!user_id || !desig_id || !email) {
      alert("Please fill all fields");
      return;
    }

    // const existing = readUsers();
    if (employeeId == null) {
      console.log("data is ", formData);
      /* */
      axios.post(`${API_BASE_URL}employee_add.php`, formData)
        .then((response) => {
          if (response.data.head.code === 200) {
            // setUserList(response.data.body);
            // setFilteredOrders(response.data.body);
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            // setUserList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          // setUserList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });


      // const id = nextUserId(existing);
      // const newUser = { id, name, designation, email, privileges: {} };
      // const updated = [...existing, newUser];
      // saveUsers(updated);
      // setUsers(updated);
    } else {
      // const updated = existing.map((u) =>
      //   u.id === editingId ? { ...u, name, designation, email } : u
      // );
      // saveUsers(updated);
      // setUsers(updated);
      console.log("====employee ============", formData);
      axios.post(`${API_BASE_URL}employee_detail_edit.php`, formData)
        .then((response) => {
          if (response.data.head.code === 200) {
            // setUserList(response.data.body);
            // setFilteredOrders(response.data.body);
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            // setUserList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          // setUserList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }

    closeModal();
  };

  // const handleRemove = (id) => {
  //   if (window.confirm("Are you sure you want to delete this user?")) {
  //     const updated = employeeList.filter((u) => u.emp_id !== id);
  //     // saveUsers(updated);
  //     // setUsers(updated);
  //     if (employeeId === id) closeModal();
  //   }
  // };

  const handleRemove = (emp_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}employee_delete.php`, { emp_id: emp_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  // Pagination (show 6 users per page; consistent with other pages using wrapper)
  const { currentPage, totalPages, currentItems, handlePageChange, indexOfFirstItem } =
    usePagination(employeeList, 25);//limit

  return (
    <>
      <Container fluid className="my-4 outer-container">
        <h2 className="text-center">Manage Permissions</h2>
        {/* {currentItems.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )} */}
        <div className="d-flex justify-content-end align-items-center mb-3">
          <Button className="btn-top" onClick={openAddModal}>
            Add Privillage
          </Button>
        </div>

        <div className="table-pagination-wrapper">
          <div className="table-pagination-content">
            <Table bordered responsive className="table-striped customer-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Email</th>
                  <th>Privileges</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.map((employee, idx) => (
                  <tr key={employee.emp_id}>
                    {/* <td>{indexOfFirstItem + idx + 1}</td> */}
                    <td>{currentItems.length - (indexOfFirstItem + idx)}</td>
                    <td>{employee.user_name}</td>
                    <td>{employee.desig_name}</td>
                    <td>{employee.email}</td>
                    <td>
                      <Link
                        to={`/privileges/${employee.emp_id}`}
                        className="action-icons"
                        title="Edit Privileges"
                      >
                        <FaUserShield size={18} />
                      </Link>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link p-0 me-3"
                        onClick={() => openEditModal(employee)}
                        title="Edit User"
                      >
                        <FaEdit className="edit-icon" />
                      </button>

                      <button
                        type="button"
                        className="btn btn-link p-0"
                        // onClick={() => handleRemove(employee.emp_id)}
                        onClick={() => {
                          if (window.confirm("Are you sure you want to delete this?")) {
                            handleRemove(employee.emp_id);
                          }
                        }}
                        title="Delete User"
                      >
                        <FaTrash className="delete-icon" />
                      </button>
                    </td>
                  </tr>
                ))}
                {currentItems.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </Container>

      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {employeeId == null ? "Add Privilege User" : "Edit Privilege User"}
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="g-3">

              {/* Designation Dropdown */}
              <Col lg={12} md={12}>
                <Form.Group controlId="desig_id">
                  <Form.Label>Designation</Form.Label>
                  <Form.Select
                    name="desig_id"
                    value={formData.desig_id}
                    onChange={handleDesignationChange}
                    required
                  >
                    <option value="">Select Designation</option>
                    {designationList.map((designation) => (
                      <option key={designation.desig_id} value={designation.desig_id}>
                        {designation.desig_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Name Dropdown */}
              <Col lg={12} md={12}>
                <Form.Group controlId="user_id">
                  <Form.Label>Name</Form.Label>
                  <Form.Select
                    name="user_id"
                    value={formData.user_id}
                    onChange={handleNameChange}
                    required
                    disabled={!formData.desig_id}   // disable until designation selected
                  >
                    <option value="">Select Name</option>
                    {filteredUsers.map((user) => (
                      <option key={user.user_id} value={user.user_id}>
                        {user.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Email field */}
              <Col lg={12} md={12}>
                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    readOnly
                    placeholder="Email will auto-fill when name is selected"
                    className="bg-light"
                  />
                </Form.Group>
              </Col>

            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button type="submit" className="btn-submit">
              {employeeId == null ? "Save" : "Update"}
            </Button>
          </Modal.Footer>
        </Form>

      </Modal>
    </>
  );
};

export default Settings;
